import { useEffect } from "react";

const BADGE_SCRIPT_SRC = "https://unpkg.com/website-carbon-badges@1.1.3/b.min.js";

export default function CarbonBadge() {
  useEffect(() => {
    // avoid injecting the script twice (e.g. React StrictMode double-invoking effects)
    if (document.querySelector(`script[src="${BADGE_SCRIPT_SRC}"]`)) return;

    const script = document.createElement("script");
    script.src = BADGE_SCRIPT_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return <div id="wcb" className="carbonbadge wcb-d"></div>;
}
